import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_useIsMobile_mjs_3e33de32__ from "../hooks/useIsMobile.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__drawer_mjs_7090027b__ from "./drawer.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__ from "./sheet.mjs";
function AdaptiveSheet({ isOpen, onClose, children, title, description, size = "md", maxWidth, maxHeight, side = "right", contentClassName, headerClassName, showHeader = true, titleComponent, headerActions }) {
    const isMobile = (0, __WEBPACK_EXTERNAL_MODULE__hooks_useIsMobile_mjs_3e33de32__.useIsMobile)();
    if (isMobile) return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__drawer_mjs_7090027b__.Drawer, {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__drawer_mjs_7090027b__.DrawerContent, {
            className: contentClassName,
            children: [
                showHeader && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__drawer_mjs_7090027b__.DrawerHeader, {
                    className: headerClassName,
                    children: [
                        titleComponent || title,
                        headerActions
                    ]
                }),
                description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__drawer_mjs_7090027b__.DrawerDescription, {
                    children: description
                }),
                children
            ]
        })
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__.Sheet, {
        open: isOpen,
        onOpenChange: onClose,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__.SheetContent, {
            className: contentClassName,
            side: side,
            size: size,
            style: {
                maxWidth: maxWidth,
                maxHeight: maxHeight
            },
            children: [
                showHeader && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__.SheetHeader, {
                    className: headerClassName,
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__.SheetTitle, {
                            children: titleComponent || title
                        }),
                        description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__sheet_mjs_f98d0fd4__.SheetDescription, {
                            children: description
                        }),
                        headerActions
                    ]
                }),
                children
            ]
        })
    });
}
export { AdaptiveSheet };

//# sourceMappingURL=adaptive-sheet.mjs.map